import { createRootRoute, Outlet } from "@tanstack/react-router";
import { AuthProvider } from "../components/layouts/AuthProvider";
import { AppShell } from "../components/layouts/AppShell";
import { I18nProvider } from "../lib/i18n";

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <AuthProvider>
      <I18nProvider>
        <AppShell />
      </I18nProvider>
    </AuthProvider>
  );
}
